

import { useState } from 'react';
import { CSVLink } from "react-csv";
import {
  Container,
  Segment,
  Header,
} from 'semantic-ui-react'
import { useQuery, gql } from '@apollo/client';

import { ResponsiveContainer } from '../ResponsiveContainer';

const GET_ROLE_DATA = gql`
query Role($sessionId: Int) {
  role(sessionId: $sessionId) {
    dataJSON
  }
}`;

const RoleDownload = ({ sessionId }: {sessionId: number}) => {
  const { loading, error, data } = useQuery(GET_ROLE_DATA, {
      variables: { sessionId }
  });
  return (<>
    {!loading && !error && data.role && data.role[0] ? (
      <CSVLink data={JSON.parse(data.role[0].dataJSON)}>Save roll</CSVLink>
        ): "Making role print out"}
    </>
  )
}

const PrintRoleForSessionButton = ({ sessionId }: { sessionId: number }) => {
  const [loadReport, setLoadReport] = useState(false);

  return (
      <>
        {loadReport ? <RoleDownload sessionId={sessionId}/> : (<>
        <button onClick={() => setLoadReport(true)}>Generate roll</button>
        </>)}
      </>
  )
}

export { PrintRoleForSessionButton }
